<script setup>
  import { onMounted, onUnmounted } from "vue";
  import { storeToRefs } from "pinia";
  import BudgetHeader from "@/components/MCampaign/Budgets/BudgetHeader.vue";
  import BudgetToolbar from "@/components/MCampaign/Budgets/BudgetToolbar.vue";
  import BudgetTable from "@/components/MCampaign/Budgets/BudgetTable.vue";
  import BudgetSidePanel from "@/components/MCampaign/Budgets/BudgetSidePanel.vue";
  import { useMCampaignStore } from "@stores/mCampaign";
  import { useCCampaignsStore } from "@stores/cCampaigns";
  import { useCAdsetsStore } from "@stores/cAdsets";
  import { useBidderTargetsStore } from "@stores/bidderTargets";
  import { useUnsavedChangesGuard } from "@/utils/composables/useUnsavedChangesGuard";
  import { useMCampaignUnsavedChanges } from "@/utils/composables/useMCampaignUnsavedChanges";
  import { useBudgetView } from "@composables/budget/useBudgetView";
  import { useBudgetSelection } from "@composables/budget/useBudgetSelection";

  const { currentMCampaign } = storeToRefs(useMCampaignStore());
  const { fetchBidderTargets } = useBidderTargetsStore();
  const { fetchCCampaigns } = useCCampaignsStore();

  const cAdsetsStore = useCAdsetsStore();
  const { fetchCAdsets, clearFiltersCAdsets } = cAdsetsStore;

  const { resetBudgetView } = useBudgetView();
  const { clearSelection } = useBudgetSelection();

  useUnsavedChangesGuard(useMCampaignUnsavedChanges().hasUnsavedChanges);

  onMounted(async () => {
    const token = currentMCampaign.value.token;
    await Promise.all([fetchCCampaigns(token), fetchCAdsets(token), fetchBidderTargets(token)]);
  });

  onUnmounted(() => {
    clearFiltersCAdsets();
    resetBudgetView();
    clearSelection();
  });
</script>

<template>
  <div
    class="flex h-[calc(100vh-100px)] w-full flex-col gap-4"
    data-cy="master-campaign-budgets-page">
    <BudgetHeader />
    <div class="grid w-full min-h-0 flex-1 grid-cols-[minmax(0,1fr)_320px] gap-4">
      <div class="flex min-h-0 flex-col overflow-hidden rounded-xl border bg-background">
        <BudgetToolbar />
        <BudgetTable />
      </div>
      <BudgetSidePanel class="overflow-auto" />
    </div>
  </div>
</template>
